import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import {Provider} from "mobx-react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Login from "./components/security/Login";
import Logout from "./components/security/Logout";
import SecuredComponent from "./components/security/SecuredComponent";
import AuthClient from "./api/auth/AuthClient";
import UserSessionStore from "./store/security/UserSessionStore";
import SecurityUiService from "./services/security/SecurityUiService";
import LoginUiService from "./services/security/LoginUiService";
import LoginStore from "./store/security/LoginStore";
import NotificationComponent from "./components/notfication/NotificationComponent";
import NotificationUiService from "./services/notification/NotificationUiService";
import Config from "./Config";
import Routes from "./api/Routes";
import SessionTimoutConfiguration from "./api/auth/SessionTimoutConfiguration";

const notificationUiService = NotificationUiService.getInstance();
const authClient = new AuthClient(Config.AUTH_API);
const userSessionStore = new UserSessionStore(authClient);
const securityUiService = new SecurityUiService(userSessionStore);
const loginUiService = new LoginUiService(new LoginStore(authClient), userSessionStore);
userSessionStore.init();

const sessionTimoutConfiguration = new SessionTimoutConfiguration(userSessionStore, Config.AUTH_API);
sessionTimoutConfiguration.configureSessionTimeout();

const stores = {
    notificationUiService,
    securityUiService,
    loginUiService
};

ReactDOM.render(
    <Provider {...stores}>
        <React.Fragment>
            <NotificationComponent/>
            <BrowserRouter>
                <Switch>
                    {/* Authentication Routes */}
                    <Route exact path={Routes.LOGIN} component={Login}/>
                    <Route exact path={Routes.LOGOUT} component={Logout}/>
                    {/* Authenticated Routes */}
                    <Route path={Routes.INDEX} component={SecuredComponent}/>
                </Switch>
            </BrowserRouter>
        </React.Fragment>
    </Provider>, document.getElementById("root")
);